var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoIcon = function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 225"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#D6A444"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M104.39 173V88.156h15.391V173zm0-100.234V57.375h15.391v15.39z"
  }))));
};
export { SvgInfoIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjI1IDIyNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgZmlsbD0iI0Q2QTQ0NCIgY3g9IjExMi41IiBjeT0iMTEyLjUiIHI9IjExMi41Ii8+PHBhdGggZD0iTTEwNC4zOTA2MjUsMTczIEwxMDQuMzkwNjI1LDg4LjE1NjI1IEwxMTkuNzgxMjUsODguMTU2MjUgTDExOS43ODEyNSwxNzMgTDEwNC4zOTA2MjUsMTczIFogTTEwNC4zOTA2MjUsNzIuNzY1NjI1IEwxMDQuMzkwNjI1LDU3LjM3NSBMMTE5Ljc4MTI1LDU3LjM3NSBMMTE5Ljc4MTI1LDcyLjc2NTYyNSBMMTA0LjM5MDYyNSw3Mi43NjU2MjUgWiIgZmlsbD0iI0ZGRiIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9nPjwvc3ZnPg==";